import styles from './PendingBody.module.css'

/** The inside of a tile with no data yet; it makes no request. */
export const PendingBody = () => <p className={styles.body}>Data pending</p>
